import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import CloseIcon from '@material-ui/icons/Close';
import MinimizeIcon from '@material-ui/icons/Minimize';
import MaximizeIcon from '@material-ui/icons/Maximize';
import CallMadeIcon from '@material-ui/icons/CallMade';
import CallReceivedIcon from '@material-ui/icons/CallReceived';
import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';

import { withStyles } from '@material-ui/core/styles';
import useMobileLayout from 'Hooks/useMobileLayout';

const styles = theme => ({
  root: {},
  icon: {
    color: theme.palette.common.black,
  },
});

function Actions({
  className,
  classes,
  minimized,
  isFullScreen,
  onClose,
  toggleMinimized,
  toggleFullScreen,
}) {
  const isMobile = useMobileLayout();
  return (
    <div className={classNames(classes.root, className)}>
      {!isMobile && (
        <IconButton
          classes={{ icon: classes.icon }}
          title={(minimized) ? 'Maximize' : 'Minimize'}
          icon={(minimized) ? MaximizeIcon : MinimizeIcon}
          onClick={(evt) => {
            evt.stopPropagation();
            toggleMinimized(`${(minimized) ? 'Maximize' : 'Minimize'} Icon`);
          }}
          IconProps={{
            fontSize: 'small',
          }}
          test="docked-item-toggle-minimized-button"
        />
      )}
      {!isMobile && (
        <IconButton
          classes={{ icon: classes.icon }}
          title={(isFullScreen) ? 'Exit Full Screen' : 'Full Screen'}
          icon={(isFullScreen) ? CallReceivedIcon : CallMadeIcon}
          onClick={(evt) => {
            evt.stopPropagation();
            toggleMinimized('Full Screen Icon', false);
            toggleFullScreen('Full Screen Icon');
          }}
          IconProps={{
            fontSize: 'small',
          }}
          test="docked-item-toggle-fullscreen-button"
        />
      )}
      <IconButton
        classes={{ icon: classes.icon }}
        title="Save and Close"
        icon={CloseIcon}
        onClick={(evt) => {
          evt.stopPropagation();
          onClose();
        }}
        IconProps={{
          fontSize: 'small',
        }}
        test="docked-item-close-button"
      />
    </div>
  );
}

Actions.defaultProps = {
  className: '',
};

Actions.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  isFullScreen: PropTypes.bool.isRequired,
  minimized: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  toggleMinimized: PropTypes.func.isRequired,
  toggleFullScreen: PropTypes.func.isRequired,
};

export default withStyles(styles)(Actions);
